export default "__VITE_ASSET__813138cc__"